import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from 'components/shared/CircularProgress';
import Form from './Form';

const IDVerification = ({ isLoading, uploading, user, onSubmit, defaultSelected }) => {
  const [sidesCount, setSidesCount] = React.useState(null);

  React.useEffect(() => {
    if (['SUCCESS', 'PENDING'].includes(user.kyc_status)) {
      setSidesCount(null);
    } else if (defaultSelected) {
      setSidesCount(defaultSelected);
    }
  }, [user.kyc_status, defaultSelected]);

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      {!!sidesCount && (
        <AppBar position="static" color="default">
          <Tabs
            value={sidesCount}
            onChange={(e, v) => setSidesCount(v)}
            aria-label="simple tabs example"
            variant="fullWidth"
            indicatorColor="primary"
          >
            {sidesCount === 2 && (
              <Tab
                value={2}
                label={
                  <FormattedMessage
                    id="Driver's license or ID card"
                    defaultMessage="Driving license or ID card"
                  />
                }
              />
            )}
            {sidesCount === 1 && (
              <Tab value={1} label={<FormattedMessage id="Passport" defaultMessage="Passport" />} />
            )}
          </Tabs>
        </AppBar>
      )}
      <Box mt={2}>
        {sidesCount === 2 && (
          <Typography variant="body2">
            <FormattedMessage
              id="verification.kyc.id.explanation"
              defaultMessage="ID verify yourself by uploading an image of your driving license or ID-card"
            />
          </Typography>
        )}
        {sidesCount === 1 && (
          <Typography variant="body2">
            <FormattedMessage
              id="verification.kyc.passport.explanation"
              defaultMessage="ID verify yourself by uploading an image of your passport"
            />
          </Typography>
        )}
      </Box>
      {!!sidesCount && (
        <Form onSubmit={onSubmit} sidesCount={sidesCount} user={user} uploading={uploading} />
      )}
    </Box>
  );
};

IDVerification.propTypes = {
  isLoading: PropTypes.bool,
  uploading: PropTypes.bool,
  user: PropTypes.shape({
    bankid_session: PropTypes.bool,
    bankid_verified_at: PropTypes.string,
    kyc_status: PropTypes.oneOf(['SUCCEDED', 'FAILED', 'PENDING', 'UNVERIFIED']),
    booking_valid: PropTypes.bool,
    can_change_name: PropTypes.bool,
    mango_user_id: PropTypes.string,
  }),
  onSubmit: PropTypes.func,
  defaultSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IDVerification;
